import type { InvoiceData, LineItemProps } from '~/components/AiChat/SideBarDialog/InvoiceRecommendationAnalysis/types';

import type { ClaimPolymorph } from '../types/claim-types';
import type { Invoice, LineItem } from '../types/invoice-types';

export const mapLineItemToLineItemProps = (item: LineItem): LineItemProps => {
  return {
    id: item.id.toString(),
    description: item.description,
    amount: item.amount,
    payable_type: item.payable_type as 'expenses' | 'indemnity' | undefined,
    covered_amount: item.covered_amount,
    coverage_decision: item.coverage_decision,
    coverage: item.coverage_key ?? undefined,
    explanation: item.explanation ?? undefined,
    amount_currency: item.amount_currency ?? undefined,
    item_date: item.item_date ?? undefined,
    exposure_id: item.exposure_id ?? undefined,
    // Currency conversion fields
    conversion_date: item.conversion_date ?? undefined,
    conversion_rate: item.conversion_rate ?? undefined,
    base_amount: item.base_amount ?? undefined,
    is_locked: item.is_locked ?? false,
    payment_request_id: item.payment_request_id ?? undefined,
    third_party_amount: item.third_party_amount ?? undefined,
    entry_type: item.entry_type ?? undefined,
  };
};

export const mapInvoiceToInvoiceData = (
  document: NonNullable<ClaimPolymorph['documents']>[number],
  invoice: Invoice
): InvoiceData => {
  return {
    date: invoice.invoice_date ?? undefined,
    number: invoice.invoice_number,
    vendor: invoice.vendor ?? undefined,
    document_claim_internal_id: document.claim_internal_id,
  };
};
